import { FormikErrors } from 'formik';
import { ExtendedLocation } from './ExtendedLocation.model';

export const locationVerification = (data: ExtendedLocation) => {
  const errors = {} as FormikErrors<ExtendedLocation>;

  if (!data.zipCode) {
    errors.zipCode = 'missing';
  }

  if (!data.countryISOA2) {
    errors.countryISOA2 = 'missing';
  }

  if (!data.street) {
    errors.street = 'missing';
  }

  if (!data.city) {
    errors.city = 'missing';
  }

  return errors;
};

export const locationDetailVerification = (data: ExtendedLocation) => {
  const errors = {} as FormikErrors<ExtendedLocation>;

  if (!data.description) {
    errors.description = 'missing';
  }

  if (!data.importantInformation) {
    errors.importantInformation = 'missing';
  }

  return errors;
};
